import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["dataIndex", "title", "sx", "isCheckbox", "isMenu", "isFirstElement", "isSortable", "_sortProps"];
import PropTypes from 'prop-types';
import * as React from 'react';
import { TableCell, Typography } from '@lumahealthhq/ui-core';
import TableSortLabel from '../ContainerTable/components/TableSortLabel';
import getDefaultStylesAndProps from './getDefaultStylesAndProps';

/**
 * @ignore - internal component.
 */
import { jsx as _jsx } from "react/jsx-runtime";
function ContainerTableColumn(_ref) {
  let {
      title,
      sx,
      isCheckbox,
      isMenu,
      isFirstElement,
      isSortable = false,
      _sortProps
    } = _ref,
    customProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    styles,
    props: defaultCellProps
  } = getDefaultStylesAndProps(!!isCheckbox, !!isMenu, !!isFirstElement);
  const props = _extends({}, defaultCellProps, customProps);
  const renderAsTitle = typeof title === 'string' || typeof title === 'number';
  const renderTitle = renderAsTitle ? /*#__PURE__*/_jsx(Typography, {
    variant: "body2",
    color: "text.secondary",
    children: title
  }) : title;
  return /*#__PURE__*/_jsx(TableCell, _extends({
    sx: theme => _extends({}, styles(theme), sx)
  }, props, {
    children: isSortable ? /*#__PURE__*/_jsx(TableSortLabel, _extends({}, _sortProps, {
      children: renderTitle
    })) : renderTitle
  }));
}
process.env.NODE_ENV !== "production" ? ContainerTableColumn.propTypes /* remove-proptypes */ = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit "ContainerTableColumnProps.ts" and run "yarn proptypes"
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  _sortProps: PropTypes.object,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  dataIndex: PropTypes.string.isRequired,
  /**
   * @ignore
   */
  isCheckbox: PropTypes.bool,
  /**
   * @ignore
   */
  isFirstElement: PropTypes.bool,
  /**
   * @ignore
   */
  isMenu: PropTypes.bool,
  /**
   * @ignore
   */
  isSortable: PropTypes.bool,
  /**
   * @ignore
   */
  render: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   */
  tableCellProps: PropTypes.object,
  /**
   * @ignore
   */
  title: PropTypes.node
} : void 0;
export default ContainerTableColumn;